import { Text, View, Image } from "@react-pdf/renderer";
import { useState } from "react";
import { useEffect } from "react";

import S_A_False from "../images/EnergyClassImgs/S_A_False.jpg";
import S_A_True from "../images/EnergyClassImgs/S_A_True.jpg";
import S_Aplus_False from "../images/EnergyClassImgs/S_Aplus_False.jpg";
import S_Aplus_True from "../images/EnergyClassImgs/S_Aplus_True.jpg";
import S_B_False from "../images/EnergyClassImgs/S_B_False.jpg";
import S_B_True from "../images/EnergyClassImgs/S_B_True.jpg";
import S_C_False from "../images/EnergyClassImgs/S_C_False.jpg";
import S_C_True from "../images/EnergyClassImgs/S_C_True.jpg";
import S_D_False from "../images/EnergyClassImgs/S_D_False.jpg";
import S_D_True from "../images/EnergyClassImgs/S_D_True.jpg";
import S_E_False from "../images/EnergyClassImgs/S_E_False.jpg";
import S_E_True from "../images/EnergyClassImgs/S_E_True.jpg";

import W_A_False from "../images/EnergyClassImgs/W_A_False.jpg";
import W_A_True from "../images/EnergyClassImgs/W_A_True.jpg";
import W_Aplus_False from "../images/EnergyClassImgs/W_Aplus_False.jpg";
import W_Aplus_True from "../images/EnergyClassImgs/W_Aplus_True.jpg";
import W_B_False from "../images/EnergyClassImgs/W_B_False.jpg";
import W_B_True from "../images/EnergyClassImgs/W_B_True.jpg";
import W_C_False from "../images/EnergyClassImgs/W_C_False.jpg";
import W_C_True from "../images/EnergyClassImgs/W_C_True.jpg";
import W_D_False from "../images/EnergyClassImgs/W_D_False.jpg";
import W_D_True from "../images/EnergyClassImgs/W_D_True.jpg";
import W_E_False from "../images/EnergyClassImgs/W_E_False.jpg";
import W_E_True from "../images/EnergyClassImgs/W_E_True.jpg";

import PlocastaKomora from "../images/PlocastaKomora.png";
import PlocastaKomoraGrejac from "../images/PlocastaKomoraGrejac.png";
import PlocastaKomoraHladnjak from "../images/PlocastaKomoraHladnjak.png";
import PlocastaKomoraHladnjakGrejac from "../images/PlocastaKomoraHladnjakGrejac.png";
import RotacionaKomora from "../images/RotacionaKomora.png";
import RotacionaKomoraGrejac from "../images/RotacionaKomoraGrejac.png";
import RotacionaKomoraHladnjak from "../images/RotacionaKomoraHladnjak.png";
import RotacionaKomoraHladnjakGrejac from "../images/RotacionaKomoraHladnjakGrejac.png";
import { useTranslation } from "react-i18next";

const EuroventInfo = ({ styles, techData, heatRecovery }) => {
  const [imgUrlSummer, setImgUlrSummer] = useState(null);
  const [imgUrlWinter, setImgUlrWinter] = useState(null);
  const [sketch, setSketch] = useState(null);
  const { t } = useTranslation();
  useEffect(() => {
    let urlImageS = techData.calculation.euroventCalculation.summerIconTag;
    switch (urlImageS) {
      case "S_A_False":
        setImgUlrSummer(S_A_False);
        break;
      case "S_A_True":
        setImgUlrSummer(S_A_True);
        break;
      case "S_A+_False":
        setImgUlrSummer(S_Aplus_False);
        break;
      case "S_A+_True":
        setImgUlrSummer(S_Aplus_True);
        break;
      case "S_B_False":
        setImgUlrSummer(S_B_False);
        break;
      case "S_B_True":
        setImgUlrSummer(S_B_True);
        break;
      case "S_C_False":
        setImgUlrSummer(S_C_False);
        break;
      case "S_C_True":
        setImgUlrSummer(S_C_True);
        break;
      case "S_D_False":
        setImgUlrSummer(S_D_False);
        break;
      case "S_D_True":
        setImgUlrSummer(S_D_True);
        break;
      case "S_E_False":
        setImgUlrSummer(S_E_False);
        break;
      case "S_E_True":
        setImgUlrSummer(S_E_True);
        break;
      default:
        break;
    }

    let urlImageW = techData.calculation.euroventCalculation.winterIconTag;
    switch (urlImageW) {
      case "W_A_False":
        setImgUlrWinter(W_A_False);
        break;
      case "W_A_True":
        setImgUlrWinter(W_A_True);
        break;
      case "W_A+_False":
        setImgUlrWinter(W_Aplus_False);
        break;
      case "W_A+_True":
        setImgUlrWinter(W_Aplus_True);
        break;
      case "W_B_False":
        setImgUlrWinter(W_B_False);
        break;
      case "W_B_True":
        setImgUlrWinter(W_B_True);
        break;
      case "W_C_False":
        setImgUlrWinter(W_C_False);
        break;
      case "W_C_True":
        setImgUlrWinter(W_C_True);
        break;
      case "W_D_False":
        setImgUlrWinter(W_D_False);
        break;
      case "W_D_True":
        setImgUlrWinter(W_D_True);
        break;
      case "W_E_False":
        setImgUlrWinter(W_E_False);
        break;
      case "W_E_True":
        setImgUlrWinter(W_E_True);
        break;
      default:
        break;
    }

    let recuperatorType = heatRecovery;
    let cooler = techData.calculation.cooling.finSpacing !== "-99";
    let heater = techData.calculation.heating.finSpacing !== "-99";

    switch (recuperatorType) {
      case "Rotary heat exchanger" || "Rotacioni izmenjivač toplote":
        if (cooler && heater) setSketch(RotacionaKomoraHladnjakGrejac);
        else if (cooler) setSketch(RotacionaKomoraHladnjak);
        else if (heater) setSketch(RotacionaKomoraGrejac);
        else setSketch(RotacionaKomora);
        break;
      default:
        if (cooler && heater) setSketch(PlocastaKomoraHladnjakGrejac);
        else if (cooler) setSketch(PlocastaKomoraHladnjak);
        else if (heater) setSketch(PlocastaKomoraGrejac);
        else setSketch(PlocastaKomora);
    }
  }, []);

  return (
    <View style={styles["section-wrapper"]}>
      <View style={styles["heading"]}>
        <Text style={styles["title"]}>
          {t("techCard.EuroventInfo.Title").toUpperCase()}
        </Text>
      </View>
      <View style={styles.flex}>
        <View style={{ ...styles.left, paddingRight: "5px" }}>
          <View style={styles["md-flex"]}>
            <Text style={styles["label"]}>
              {t("techCard.EuroventInfo.ModelBox")}:
            </Text>
            <Text style={styles["value"]}>
              {techData.calculation.euroventCalculation.modelBox}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles["wide-label"]}>
              {t("techCard.EuroventInfo.WorkingTempAhu")} [°C]:
            </Text>
            <Text style={styles["value"]}>
              {techData.calculation.euroventCalculation.workTempMin} /{" "}
              {techData.calculation.euroventCalculation.workTempMax}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles["wide-label"]}>
              {t("techCard.EuroventInfo.WinterOutTemp")} [°C]:
            </Text>
            <Text style={styles["value"]}>
              {/*techData.calculation.euroventCalculation.winterOutdoorTemp*/}
              {techData.calculation.winterRecCalculation.sup_AirTempIn}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles["wide-label"]}>
              {/*t("techCard.EuroventInfo.SFPValidation")*/} SFPv = 0.9*SFPe
              [W/m3/s]
            </Text>
            <Text style={styles["value"]}>
              {techData.calculation.euroventCalculation.specificFanPower}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles["wide-label"]}>
              {t("techCard.EuroventInfo.SFPClass")} (DIN EN 16798-3):
            </Text>
            <Text style={styles["value"]}>
              {techData.calculation.euroventCalculation.classSFP}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles["label"]}>
              {t("techCard.EuroventInfo.Altitude")} [m]:
            </Text>
            <Text style={styles["value"]}>
              {techData.calculation.euroventCalculation.altitude}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles["label"]}>
              {t("techCard.EuroventInfo.AirDens")} [kg/m³]:
            </Text>
            <Text style={styles["value"]}>
              {techData.calculation.euroventCalculation.airDensity}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles["label"]}>
              fs-Pref {t("techCard.EuroventInfo.FsPrefWinSum")}
            </Text>
            <Text style={styles["value"]}>
              {techData.calculation.euroventCalculation.fsPrefWinter} /{" "}
              {techData.calculation.euroventCalculation.fsPrefSummer}
            </Text>
          </View>

          <View style={styles["img-center"]}>
            <Image
              src={sketch}
              alt="test"
              style={{
                width: "76mm",
                height: "44mm",
              }}
            />
          </View>
        </View>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            width: "50%",
          }}
        >
          <View
            style={{
              display: "flex",
              flexDirection: "column",
              width: "50%",
            }}
          >
            {/* <Image src={imgUrlSummer} alt="test" /> */}
            <Image
              src={imgUrlSummer}
              style={{
                marginTop: 15,
                width: "36mm",
                height: "41mm",
              }}
            />
            <Image
              src={imgUrlWinter}
              style={{
                width: "36mm",
                height: "41mm",
              }}
            />
          </View>
          {/* <View style={styles.flex}>*/}
          <View
            style={{
              marginTop: 30,
            }}
          >
            <View style={styles["md-flex"]}>
              <Text style={styles["label"]}>
                {t("techCard.EuroventInfo.SummerApplication")}
              </Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={styles["label"]}>{techData.location}</Text>
            </View>

            <View style={styles["md-flex"]}>
              <Text style={styles["label"]}>
                {t("techCard.EuroventInfo.DesignDryBulb")}
              </Text>
              <Text style={styles["value"]}>
                {" "}
                {
                  techData.calculation.euroventCalculation
                    .designDryBulbTemperature
                }{" "}
                °C
              </Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={styles["label"]}>
                {t("techCard.EuroventInfo.DesignDewPoint")}
              </Text>
              <Text style={styles["value"]}>
                {" "}
                {
                  techData.calculation.euroventCalculation
                    .designDewPointTemperature
                }{" "}
                °C
              </Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={styles["label"]}>
                {t("techCard.EuroventInfo.DesignWetBulb")}
              </Text>
              <Text style={styles["value"]}>
                {" "}
                {
                  techData.calculation.euroventCalculation
                    .designWetBulbTemperature
                }{" "}
                °C
              </Text>
            </View>
          </View>
          {/* </View>*/}
          {/* <Image
            src={require("../../../image/Termovent-logo.png")}
            alt="test"
            cache={false}
          /> */}
        </View>
      </View>
    </View>
  );
};

export default EuroventInfo;
